import script from "./CarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&setup=true&lang=js"

import "./CarouselComponent.vue?vue&type=style&index=0&id=11607b91&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11607b91"]])

export default __exports__